import { Modal, ModalProps } from "react-bootstrap";
import { getPortraitStageContainer } from "../PortraitStage";
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import CrossFailure from "../icon/CrossFailure";

interface FailureScanModalProps extends ModalProps {
  message?: string;
  onHide: () => void;
  redirectHomeAfterMs?: number;
}

const FailureScanModal = ({
  message,
  redirectHomeAfterMs = 5000,
  ...props
}: FailureScanModalProps) => {
  const navigate = useNavigate();

  useEffect(() => {
    const timer = setTimeout(() => {
      navigate("/");
    }, redirectHomeAfterMs);

    return () => clearTimeout(timer);
  }, [navigate, redirectHomeAfterMs]);

  return (
    <Modal
      container={getPortraitStageContainer}
      {...props}
      aria-labelledby="contained-modal-title-vcenter"
      centered
      className="commonModal"
      backdrop="static"
    >
      <Modal.Body className="text-center" style={{ padding: 48 }}>
        <CrossFailure />
        <div className="loaderTxtScan">
          {message || "Unable to verify ticket. Please try again."}
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default FailureScanModal;
